var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[(_vm.$route.meta.isLogin)?_c('router-view'):_vm._e(),(_vm.$route.meta.isAdmin)?_c('admin-home'):_vm._e(),(_vm.Showhome)?_c('Home'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }